import React from 'react';
import { Box } from '@mui/material';
import { jsonForm, visibilityType } from '@europrocurement/flexy-form/utils/types/formTypes';
import { CustomOptionResolvers } from '@europrocurement/flexy-form';

// eslint-disable-next-line import/no-cycle
import JsonForm from '../../JsonForm';

export type nomsDeDomaineModalProps = {
    onChange: (currentPage: number, pageLength: number, data?: Record<string, unknown>) => void;
    json: jsonForm;
    defaultValues: Record<string, unknown>;
    customOptionResolvers: CustomOptionResolvers;
    visibility?: visibilityType;
};

const NomsDeDomaineModal: React.FunctionComponent<nomsDeDomaineModalProps> = function ({
    onChange,
    json,
    defaultValues,
    customOptionResolvers,
    visibility,
}: nomsDeDomaineModalProps) {
    return (
        <Box sx={{ width: '60%', margin: 'auto' }}>
            <JsonForm
                onChange={onChange}
                visibility={visibility || 'FULL'}
                debugMode={false}
                json={json as jsonForm}
                startPage={0}
                defaultValues={defaultValues}
                customOptionResolvers={customOptionResolvers}
                submitLabel="Enregistrer les informations"
                submitStyle={{
                    marginTop: '30px',
                    padding: '20px 25px',
                    fontSize: '1rem',
                    borderRadius: '15px',
                    marginLeft: 'auto',
                    marginRight: 'auto',
                }}
            />
        </Box>
    );
};

export default NomsDeDomaineModal;
